import React from 'react';

import { TabItem } from './types';

type TabNavProps = {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
};

const TabNav: React.FC<TabNavProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <nav className='flex'>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`w-full border-b-2 border-solid p-4 xl:px-2 xl:text-sm lg:px-1 ${activeTab === tab.id ? 'border-b-primary-500 font-semibold text-primary-500' : 'border-b-gray-200'}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
};

export default TabNav;
